// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1307":"06623dae","2246":"04f4dc59","2649":"772daee2","3063":"31652d10"}[chunkId] + ".chunk.css";
};